var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFolderWhite = function SvgFolderWhite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 11.0833C12.8334 11.3928 12.7105 11.6895 12.4917 11.9083C12.2729 12.1271 11.9762 12.25 11.6667 12.25H2.33341C2.024 12.25 1.72725 12.1271 1.50846 11.9083C1.28966 11.6895 1.16675 11.3928 1.16675 11.0833V2.91667C1.16675 2.60725 1.28966 2.3105 1.50846 2.09171C1.72725 1.87292 2.024 1.75 2.33341 1.75H5.25008L6.41675 3.5H11.6667C11.9762 3.5 12.2729 3.62292 12.4917 3.84171C12.7105 4.0605 12.8334 4.35725 12.8334 4.66667V11.0833Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder-white.725e3f96.svg";
export { ForwardRef as ReactComponent };